export default "__VITE_ASSET__a634d4f0__"